import SectionCounter1 from "./section-counter1";
import {
  FaRocket,
  FaStore,
  FaBuilding,
  FaShoppingCart,
  FaHeartbeat,
  FaGraduationCap,
  FaHome,
  FaUniversity,
  FaLaptopCode,
  FaIndustry,
  FaTruck,
  FaPlane,
  FaFilm,
  FaLandmark,
  FaSeedling,
  FaSolarPanel,
} from "react-icons/fa";

function SectionAboutCompany1() {
  return (
    <>
      <div className="section-full p-t40 pb-2 sx-bg-white sx-about-bx1-outer">
        <div className="container">
          <div className="section-content">
            {/* HEADING */}
            <div className="text-center mb-5">
              <h2 className="sx-title">Industries We Serve</h2>
              <span className="sx-title-2">
                At DArch Tech, we work with businesses across all industries,
                delivering scalable digital solutions that meet unique business
                challenges and customer needs.
              </span>
            </div>

            {/* FEATURES GRID */}
            <div className="row sx-about-icon-bx1-column">
              <div className="col-lg-3 col-md-4 col-sm-6 m-b30">
                <div className="sx-icon-bx text-center ">
                  <div className="sx-media">
                    <FaRocket size={34} />
                  </div>
                  <span className="sx-icon-bx-title">
                    Startups & Entrepreneurs
                  </span>
                </div>
              </div>

              <div className="col-lg-3 col-md-4 col-sm-6 m-b30">
                <div className="sx-icon-bx text-center">
                  <div className="sx-media">
                    <FaStore size={34} />
                  </div>
                  <span className="sx-icon-bx-title">SMEs</span>
                </div>
              </div>

              <div className="col-lg-3 col-md-4 col-sm-6 m-b30">
                <div className="sx-icon-bx text-center">
                  <div className="sx-media">
                    <FaBuilding size={34} />
                  </div>
                  <span className="sx-icon-bx-title">
                    Corporate & Enterprises
                  </span>
                </div>
              </div>

              <div className="col-lg-3 col-md-4 col-sm-6 m-b30">
                <div className="sx-icon-bx text-center">
                  <div className="sx-media">
                    <FaShoppingCart size={34} />
                  </div>
                  <span className="sx-icon-bx-title">E-commerce & Retail</span>
                </div>
              </div>

              <div className="col-lg-3 col-md-4 col-sm-6 m-b30">
                <div className="sx-icon-bx text-center">
                  <div className="sx-media">
                    <FaHeartbeat size={34} />
                  </div>
                  <span className="sx-icon-bx-title">
                    Healthcare & Wellness
                  </span>
                </div>
              </div>

              <div className="col-lg-3 col-md-4 col-sm-6 m-b30">
                <div className="sx-icon-bx text-center">
                  <div className="sx-media">
                    <FaGraduationCap size={34} />
                  </div>
                  <span className="sx-icon-bx-title">
                    Education & E-Learning
                  </span>
                </div>
              </div>

              <div className="col-lg-3 col-md-4 col-sm-6 m-b30">
                <div className="sx-icon-bx text-center">
                  <div className="sx-media">
                    <FaHome size={34} />
                  </div>
                  <span className="sx-icon-bx-title">
                    Real Estate & Construction
                  </span>
                </div>
              </div>

              <div className="col-lg-3 col-md-4 col-sm-6 m-b30">
                <div className="sx-icon-bx text-center">
                  <div className="sx-media">
                    <FaUniversity size={34} />
                  </div>
                  <span className="sx-icon-bx-title">Finance & FinTech</span>
                </div>
              </div>

              <div className="col-lg-3 col-md-4 col-sm-6 m-b30">
                <div className="sx-icon-bx text-center">
                  <div className="sx-media">
                    <FaLaptopCode size={34} />
                  </div>
                  <span className="sx-icon-bx-title">IT, Software & SaaS</span>
                </div>
              </div>

              <div className="col-lg-3 col-md-4 col-sm-6 m-b30">
                <div className="sx-icon-bx text-center">
                  <div className="sx-media">
                    <FaIndustry size={34} />
                  </div>
                  <span className="sx-icon-bx-title">
                    Manufacturing & Industrial
                  </span>
                </div>
              </div>

              <div className="col-lg-3 col-md-4 col-sm-6 m-b30">
                <div className="sx-icon-bx text-center">
                  <div className="sx-media">
                    <FaTruck size={34} />
                  </div>
                  <span className="sx-icon-bx-title">
                    Logistics & Transportation
                  </span>
                </div>
              </div>

              <div className="col-lg-3 col-md-4 col-sm-6 m-b30">
                <div className="sx-icon-bx text-center">
                  <div className="sx-media">
                    <FaPlane size={34} />
                  </div>
                  <span className="sx-icon-bx-title">Travel & Hospitality</span>
                </div>
              </div>

              <div className="col-lg-3 col-md-4 col-sm-6 m-b30">
                <div className="sx-icon-bx text-center">
                  <div className="sx-media">
                    <FaFilm size={34} />
                  </div>
                  <span className="sx-icon-bx-title">
                    Media & Entertainment
                  </span>
                </div>
              </div>

              <div className="col-lg-3 col-md-4 col-sm-6 m-b30">
                <div className="sx-icon-bx text-center">
                  <div className="sx-media">
                    <FaLandmark size={34} />
                  </div>
                  <span className="sx-icon-bx-title">
                    Government & Public Sector
                  </span>
                </div>
              </div>
              <div className="col-lg-3 col-md-4 col-sm-6 m-b30">
                <div className="sx-icon-bx text-center">
                  <div className="sx-media">
                    <FaSeedling size={34} />
                  </div>
                  <span className="sx-icon-bx-title">
                    Agriculture & AgriTech
                  </span>
                </div>
              </div>
              <div className="col-lg-3 col-md-4 col-sm-6 m-b30">
                <div className="sx-icon-bx text-center">
                  <div className="sx-media">
                    <FaSolarPanel size={34} />
                  </div>
                  <span className="sx-icon-bx-title">
                    Energy & Sustainability
                  </span>
                </div>
              </div>
            </div>

            {/* COUNTER */}
            <SectionCounter1 />
          </div>
        </div>
      </div>
    </>
  );
}

export default SectionAboutCompany1;
